import React, {
  useContext,
  useState,
  useRef,
  useCallback,
  useEffect,
  Fragment,
  useMemo,
} from 'react';
import { Context } from '../../../context/AppContext';
import getParamFilterValue from '../../../utils/getParamFilterValue';
import matchArrays from '../../../utils/matchArrays';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { TRADING_HOURS_FILTER_ICONS, FILTERS } from '../../../constants';
import DropDown from './DropDown';
import NavButton from './NavButton';
import CheckBox from './CheckBox';
import ApplyButton from './ApplyButton';
import './styles.css';

const { OPENING_HOURS } = FILTERS;

const TradingHours = ({
  fetchMore,
  filters,
  filter,
  selectedCount,
  filtersCount,
  updateFiltersCount,
  sort,
}) => {
  const {
    media: { tablet, desktop, mobile },
  } = useContext(Context);
  const [selected, setSelected] = useState('');
  const [dirty, setDirty] = useState();
  const [dropdownFilters, setDropdownFilters] = useState([]);

  const [show, setShow] = useState();
  const ref = useRef();

  useEffect(() => {
    setSelected(filter);
    setDirty(false);
  }, [filter]);

  useEffect(() => {
    setDropdownFilters(filters);
  }, [filters]);

  const matchInitial = useMemo(() => {
    return matchArrays(
      selected ? selected.split(',').sort() : [],
      filter ? filter.split(',').sort() : []
    );
  }, [selected, filter]);

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (show) {
        setSelected(filter);
        updateFiltersCount(filter);
        setShow(false);
      }
    }, [filter, show])
  );

  const setFilter = useCallback(
    (value, add) => {
      const paramFilter = getParamFilterValue(selected, value, add);
      setSelected(paramFilter);
      updateFiltersCount(paramFilter);
      setDirty(true);
    },
    [selected]
  );

  const selectedValues = useMemo(
    () =>
      selected
        ? OPENING_HOURS.reduce((agg, { label, value }) => {
            if (selected.includes(value)) {
              return agg.concat(label);
            }
            return agg;
          }, [])
        : null,
    [selected]
  );

  return (
    <div className="Listview__Filters__wrapper" ref={ref}>
      {mobile && (
        <Fragment>
          {dropdownFilters.map(({ label, checked, value }) => (
            <Fragment key={label}>
              {checked || (label === 'Open Now' && filtersCount[value] > 0) ? (
                <NavButton
                  active={checked}
                  onClick={e => {
                    const paramFilter = getParamFilterValue(
                      selected,
                      value,
                      !checked
                    );
                    setSelected(paramFilter);
                    fetchMore(e, {
                      page: 0,
                      filter: paramFilter,
                      sort,
                    });
                  }}
                >
                  {label}{' '}
                  {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                </NavButton>
              ) : (
                ''
              )}
            </Fragment>
          ))}
        </Fragment>
      )}
      {(tablet || desktop) && (
        <Fragment>
          <NavButton
            className="Listview__Filters__button--tradingHours"
            active={!!selectedCount || show}
            onClick={() => setShow(!show)}
            hasSelected={selectedCount}
          >
            Trading Hours
          </NavButton>
          <DropDown show={show} heading="Trading Hours">
            <div className="Listview__Filters__options">
              {show &&
                dropdownFilters &&
                !!dropdownFilters.length &&
                dropdownFilters.map(({ label, checked, value }) => (
                  <CheckBox
                    key={label}
                    defaultChecked={checked}
                    disabled={!filtersCount[value] && !checked}
                    value={value}
                    onClick={e => setFilter(e.target.value, e.target.checked)}
                    svg={focused =>
                      TRADING_HOURS_FILTER_ICONS(
                        label,
                        focused || (selected || '').indexOf(value) > -1
                      )
                    }
                  >
                    {label}{' '}
                    {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                  </CheckBox>
                ))}
            </div>
            <ApplyButton
              active={dirty && !matchInitial}
              data-filter={selectedValues}
              onClick={e => {
                fetchMore(e, {
                  page: 0,
                  filter: selected,
                  sort,
                });
                setShow(false);
              }}
            >
              Apply
            </ApplyButton>
          </DropDown>
        </Fragment>
      )}
    </div>
  );
};

export default TradingHours;
